import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelUnassignAccountVipStatus} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class UnassignAccountVipStatusFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.unassignAccountVipStatus({accountId: this.props.accountId})
      .then((response) => {
        if (response.data.unassignAccountVipStatus.errors.length <= 0) {
          this.props.cancelUnassignAccountVipStatus();
        } else {
          let errors = createValidationErrors(response.data.unassignAccountVipStatus.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelUnassignAccountVipStatus();
  }

  render() {
    return (
      <Form
        message="This will unassign VIP status for the account and will apply the current active pricelist for the shop. The account will no longer have subscription prices for one-time orders, unless they have an active subscription. Do you want to proceed?"
        submitLabel="Proceed"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        errors={this.state.errors}
        />
    )
  }
}

const UNASSIGN_ACCOUNT_VIP_STATUS = gql`
  mutation unassignAccountVipStatus($data: UnassignAccountVipStatusInput!) {
    unassignAccountVipStatus(input: $data) {
      errors { key message }
    }
  }
`;


const withQueries = compose(
  graphql(UNASSIGN_ACCOUNT_VIP_STATUS, {
    props: ({ mutate }) => ({
      unassignAccountVipStatus: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelUnassignAccountVipStatus})(withQueries(UnassignAccountVipStatusFormContainer));